import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

import '../Auth/styles.css';

class EmailVerificationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSending: false,
      isChecking: false,
      message: null,
      error: null,
    };
  }

  onCheckVerification = () => {
    this.setState({ isChecking: true, error: null, message: null });

    // Reload the user to get the latest emailVerified status
    this.props.firebase.auth.currentUser.reload()
      .then(() => {
        const user = this.props.firebase.auth.currentUser;
        
        if (user.emailVerified) {
          // Force a full page reload to refresh the auth context
          window.location.href = ROUTES.DASHBOARD;
        } else {
          this.setState({
            isChecking: false,
            error: { message: 'Email not verified yet. Please check your inbox and click the verification link.' }
          });
        }
      })
      .catch(error => {
        this.setState({ isChecking: false, error });
      });
  };

  onSendEmailVerification = () => {
    this.setState({ isSending: true, error: null, message: null });
    
    this.props.firebase
      .doSendEmailVerification()
      .then(() => {
        this.setState({
          isSending: false,
          message: 'Verification email sent! Please check your inbox.',
        });
      })
      .catch(error => {
        this.setState({ isSending: false, error });
      });
  };

  render() {
    const { isSending, isChecking, message, error } = this.state;

    return (
      <div className="auth-page">
        <div className="auth-hero">
          {/* Decorative background elements */}
          <div className="hero-motif">
            <div className="hero-motif-gradient-1" />
            <div className="hero-motif-gradient-2" />
            <div className="hero-motif-gradient-3" />
            <span className="hero-motif-line" />
            <div className="hero-motif-orb" />
          </div>
          
          <div className="auth-hero-content">
            <span className="auth-overline">Douglas &amp; McCartney</span>
            <h1 className="auth-title headline-reveal">Almost there.</h1>
            <p className="auth-subtitle">Verify your email to complete your account setup.</p>
          </div>
        </div>

        <div className="auth-form-panel">
          <div className="auth-form-card">
            <header className="auth-form-header">
              <span className="auth-brand-wordmark">Douglas &amp; McCartney</span>
              <h2>Verify your email</h2>
              <p>Check your email (including spam folder) for a confirmation link.</p>
            </header>

            <div style={{
              padding: '2rem',
              background: 'linear-gradient(135deg, #ffffff 0%, #f3f3f3 100%)',
              borderRadius: '20px',
              border: '1.5px solid #d2d2d2',
              textAlign: 'center'
            }}>
              <svg 
                style={{ 
                  width: '4rem', 
                  height: '4rem', 
                  margin: '0 auto 1.5rem',
                  color: '#111111'
                }}
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={1.5} 
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
                />
              </svg>

              <h3 style={{
                margin: '0 0 1rem 0',
                fontSize: '1.5rem',
                fontFamily: 'var(--font-serif)',
                color: 'var(--auth-charcoal)'
              }}>
                Check your inbox
              </h3>

              <p style={{
                margin: '0 0 2rem 0',
                fontSize: '1rem',
                color: 'rgba(10, 10, 10, 0.72)',
                lineHeight: '1.6'
              }}>
                We sent a verification link to your email address. Click the link to activate your account.
              </p>

              {message && (
                <div style={{
                  margin: '0 0 1.5rem 0',
                  padding: '0.75rem 1rem',
                  background: '#f2f2f2',
                  border: '1px solid #d2d2d2',
                  borderRadius: '14px',
                  fontSize: '0.85rem',
                  fontWeight: '600',
                  color: '#111111'
                }}>
                  {message}
                </div>
              )}

              {error && (
                <div style={{
                  margin: '0 0 1.5rem 0',
                  padding: '0.75rem 1rem',
                  background: '#f2f2f2',
                  border: '1px solid #c7c7c7',
                  borderRadius: '14px',
                  fontSize: '0.85rem',
                  fontWeight: '600',
                  color: '#111111'
                }}>
                  {error.message}
                </div>
              )}

              <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: '1rem',
                alignItems: 'center' 
              }}>
                <button
                  type="button"
                  onClick={this.onCheckVerification}
                  disabled={isChecking}
                  className="auth-submit"
                  style={{ 
                    width: 'auto', 
                    padding: '0.75rem 2rem',
                    background: 'linear-gradient(135deg, #1a1a1a 0%, #050505 100%)',
                    border: '2px solid #1a1a1a',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.35)'
                  }}
                >
                  {isChecking ? 'Checking...' : 'I have verified my email'}
                </button>

                <button
                  type="button"
                  onClick={this.onSendEmailVerification}
                  disabled={isSending}
                  style={{
                    padding: '0.75rem 2rem',
                    fontSize: '0.9rem',
                    fontWeight: '600',
                    color: 'var(--auth-charcoal)',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    transition: 'all 0.3s ease'
                  }}
                >
                  {isSending ? 'Sending...' : 'Resend verification email'}
                </button>
              </div>
            </div>

            <div style={{ 
              marginTop: '2rem',
              textAlign: 'center'
            }}>
              <p style={{
                margin: '0',
                fontSize: '0.85rem',
                color: 'rgba(10, 10, 10, 0.62)'
              }}>
                Need help?{' '}
                <a 
                  href="mailto:partnerships@douglasmccartney.com"
                  style={{
                    color: 'var(--auth-charcoal)',
                    fontWeight: '600',
                    textDecoration: 'none'
                  }}
                >
                  Contact support
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(withFirebase(EmailVerificationPage));
